// Segnalazione degli errori dell'app.
//
// Quando una schermata si rompe sul telefono di un cliente, oggi non ne resta
// traccia: lo si scopre solo se la persona lo dice al personal trainer. Con
// questo si vede subito cosa si e' rotto e su quanti dispositivi.
//
// Senza VITE_SENTRY_DSN configurato non fa nulla e l'app funziona come
// prima.

import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export const attivo = Boolean(dsn);

// Gli utenti sono clienti di una palestra: dagli errori non deve uscire nulla
// che li riguardi. Restano il tipo di errore e il punto del codice.
const rimuoviDatiPersonali = (evento) => {
    delete evento.user;

    if (evento.request) {
        delete evento.request.cookies;
        delete evento.request.data;

        if (typeof evento.request.url === 'string') {
            evento.request.url = evento.request.url.replace(/[^/?&=]+@[^/?&=]+/g, '(email)');
        }
    }

    // Anche i passaggi che portano all'errore possono contenere indirizzi.
    if (Array.isArray(evento.breadcrumbs)) {
        evento.breadcrumbs = evento.breadcrumbs.map((passaggio) => {
            const ripulito = { ...passaggio };
            delete ripulito.data;
            if (typeof ripulito.message === 'string') {
                ripulito.message = ripulito.message.replace(/[^\s/?&=]+@[^\s/?&=]+/g, '(email)');
            }
            return ripulito;
        });
    }

    return evento;
};

export const avvia = () => {
    if (!attivo) return;

    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0,
        sendDefaultPii: false,
        beforeSend: rimuoviDatiPersonali,
    });
};

// Usata dall'ErrorBoundary per segnalare le schermate che non si caricano.
export const segnalaErrore = (errore, informazioni) => {
    if (!attivo) return;
    Sentry.captureException(errore, { extra: { componente: informazioni?.componentStack } });
};

const monitoraggio = { avvia, segnalaErrore, attivo };

export default monitoraggio;
